export const orderFields = [
    'SHIP_METHOD',
    'TRANS_ORDER_ID',
    'CARD_MESSAGE',
    'CARD_MESSAGE_TO',
    'CARD_MESSAGE_FROM',
    'address',
    'items',
    'samples',
    'kits',
    'giftWrap',
    'electronicDeliveryItemsOnly',
    'egiftcardsOnly',
    'giftcardsOnly',
    'offerCodes'
];
